/**
 * @generated SignedSource<<feb42e4781ca9b2c65dfb1cea1d1889b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type NoStorePageQuery$variables = {
  skip: boolean;
};
export type NoStorePageQuery$data = {
  readonly hasStore?: boolean;
  readonly home: {
    readonly __typename: string;
  } | null;
};
export type NoStorePageQuery = {
  response: NoStorePageQuery$data;
  variables: NoStorePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = {
  "condition": "skip",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasStore",
      "storageKey": null
    }
  ]
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NoStorePageQuery",
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "home",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NoStorePageQuery",
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "home",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v3/*: any*/),
            "type": "Node",
            "abstractKey": "__isNode"
          },
          {
            "kind": "InlineFragment",
            "selections": (v3/*: any*/),
            "type": "Organisation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fdc9a5c5600e8f680308fbf6bb49a4c7",
    "id": null,
    "metadata": {},
    "name": "NoStorePageQuery",
    "operationKind": "query",
    "text": "query NoStorePageQuery(\n  $skip: Boolean!\n) {\n  hasStore @skip(if: $skip)\n  home {\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on Organisation {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f5e8733b975f206fa37fe6150cdc39c8";

export default node;
